__turbopack_context__.v({
  "card": "o0iW9G_card",
  "cardLink": "o0iW9G_cardLink",
  "image": "o0iW9G_image",
  "meta": "o0iW9G_meta",
  "text": "o0iW9G_text",
  "titles": "o0iW9G_titles",
});
